import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';
import Profile from './Profile';

interface UserInfo {
  email?: string;
  name?: string,
}

const UserProfileDisplay: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      setName(null);
    } else {

      oktaAuth
        .getUser()
        .then((info: UserInfo) => {
          setName(info.name || '')
        })
        .catch((err) => {
          console.error('Failed to fetch user info:', err);
        });
    }
  }, [authState, oktaAuth]);

  const handleLogout = async () => {
    await oktaAuth.signOut();
  };

  return (
    <div className="flex items-center gap-4">
      {name ? (
       <Profile name={name ?? 'No Email'} handleLogout={handleLogout}/>

      ) : (
        <Link to="/profile" className="ts-app-bar-link">
          My Profile
        </Link>
      )}
    </div>
  );
};

export default UserProfileDisplay;
